import {
  setLoadingConfigObject,
  shimmerPlaceholderConfig,
} from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import styles from './AddPaymentCard.LoadingConfig.styles';

const loadingConfig = [
  {
    main: setLoadingConfigObject('square', 1, null, styles.cardNoInput),
  },
  {
    main: setLoadingConfigObject('square', 1, null, styles.nameOnCardInput),
  },
  {
    left: setLoadingConfigObject('square', 1, null, styles.expiryDate),
    right: setLoadingConfigObject('square', 1, null, styles.cvvInput),
  },
  {
    main: setLoadingConfigObject('square', 1, null, styles.cardNameInput),
  },
  {
    left: setLoadingConfigObject('circle', 1, 33, styles.secureIcon),
    main: setLoadingConfigObject('line', 2, '83%', styles.secureDescription),
  },
];

export { loadingConfig, shimmerPlaceholderConfig };
